/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Empty_TitleInputs */

const en_contact_empty_title = /** @type {(inputs: Contact_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No contact details yet`)
};

const pl_contact_empty_title = /** @type {(inputs: Contact_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak danych kontaktowych`)
};

/**
* | output |
* | --- |
* | "No contact details yet" |
*
* @param {Contact_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_empty_title = /** @type {((inputs?: Contact_Empty_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Empty_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_empty_title(inputs)
	return en_contact_empty_title(inputs)
});